import { UseFormRegisterReturn, UseFormSetValue } from 'react-hook-form';

export enum RangeVariants {
  Primary = 'primary',
  Secondary = 'secondary',
}

export type FormValues = {
  range: number;
};

export type RangeProps = {
  /** Adds a class to the list of classnames which adds CSS classes to the dom element */
  className?: string;
  /** dom ID of the range */
  domId: string;
  /** Whether or not the range should be disabled from user interaction. */
  isDisabled?: boolean;
  /** Label text */
  label?: string;
  /** The maximum value of the range. */
  max?: number;
  /** The minimum value of the range. */
  min?: number;
  /** Optional onChange handler. Callback that fires when the range value changes */
  onChange?: (value: number) => unknown;
  /** An array of custom range options */
  options?: string[];
  /** register from react-hook-from useForm hook that registers the component for a form */
  register: UseFormRegisterReturn;
  /** If the field is not required, then set this to false. */
  required?: boolean;
  /** if true the label include the current range value */
  showValueInLabel?: boolean;
  /** Number that specifies the granularity that the value must adhere to as it changes. */
  step?: number;
  /** Test ID for React Testing Library */
  testId?: string;
  /** The amount of points along the range track. */
  tickCount: number;
  /** Label left text */
  leftLabel?: string;
  /** Label right text */
  rightLabel?: string;
  /** Variant of Range */
  variant?: RangeVariants;
  /** Initial value of range */
  initialValue?: number;
  /** Enable tick interaction */
  enableTickInteraction?: boolean;
  /** Callback to set the value of the range */
  setValue?: UseFormSetValue<FormValues>;
  /** Use debounce for onChange */
  useDebounce?: boolean;
};
